export const Beautyapi = [
  {
    id: 1,
    image:
      "https://www.lizzieinlace.com/wp-content/uploads/2020/06/2-pink-beauty-products.jpg",
  },
  {
    id: 2,
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcShOQ5fovCoDYP6hmWlbjqyFPPAdX0IxYpmGg&usqp=CAU",
  },
  {
    id: 3,
    image:
      "https://png.pngtree.com/thumb_back/fh260/background/20230413/pngtree-makeup-skin-care-products-cosmetics-beauty-photography-advertising-background-image_2218552.jpg",
  },
];
